import React, { useCallback, useRef } from 'react';
import { Container } from '@mui/material';
import { ArrowBackOutlined, ArrowForwardOutlined } from '@mui/icons-material';
import { ClassNameMap } from '@mui/styles';

type InstallBannerProps = {
  imageSrc: string | undefined;
  classes: ClassNameMap;
};

export const InstallBanner: React.FC<InstallBannerProps> = ({
  imageSrc,
  classes
}: InstallBannerProps) => {
  const errored = useRef(false);
  const retryLoad = useCallback(
    ({ currentTarget }) => {
      if (!errored.current) {
        errored.current = true;
        currentTarget.onerror = null; // prevents looping
        currentTarget.src = imageSrc;
      }
    },
    [imageSrc]
  );

  return (
    <Container className={classes.containerRow}>
      <img
        className={classes.tiLogo}
        alt="ZT-logo"
        src="https://zt.replicon.com/collectors/static/ti/logo.svg"
      />
      <div className={classes.containerCol}>
        <ArrowBackOutlined className={classes.arrowIconForward} />
        <ArrowForwardOutlined className={classes.arrowIconBack} />
      </div>
      <div className={classes.collectorImage}>
        <img alt="collector-logo" src={imageSrc} onError={retryLoad} />
      </div>
    </Container>
  );
};
